import React from 'react';
import { StarIcon } from 'lucide-react';
interface HeroTestimonialCardProps {
  name: string;
  role: string;
  quote: string;
  result: string;
  highlight?: string;
  imageUrl?: string;
}
export function HeroTestimonialCard({
  name,
  role,
  quote,
  result,
  highlight,
  imageUrl
}: HeroTestimonialCardProps) {
  return <div className="bg-slate-800/70 backdrop-blur-sm p-8 rounded-2xl shadow-2xl border border-fuchsia-500/30 hover:shadow-cyan-500/30 hover:border-cyan-500/40 transition-all duration-300 relative overflow-hidden group" data-id="element-100">
      <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/5 to-fuchsia-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-101"></div>
      <div className="absolute top-0 right-0 w-48 h-48 bg-gradient-to-br from-cyan-500/10 to-transparent rounded-full blur-3xl" data-id="element-102"></div>
      <div className="relative" data-id="element-103">
        <div className="flex gap-1 mb-6" data-id="element-104">
          {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-6 h-6 fill-cyan-400 text-cyan-400" data-id="element-105" />)}
        </div>
        <p className="text-cyan-50 text-lg mb-6 italic font-medium leading-relaxed" data-id="element-106">
          "{quote}"
        </p>
        {highlight && <div className="bg-gradient-to-r from-cyan-500/20 to-fuchsia-500/20 border border-cyan-400/30 px-4 py-3 rounded-xl mb-6" data-id="element-107">
            <p className="text-white font-bold text-base" data-id="element-108">{highlight}</p>
          </div>}
        <div className="border-t border-fuchsia-500/30 pt-6" data-id="element-109">
          <div className="flex items-center gap-4 mb-4" data-id="element-110">
            {imageUrl && <img src={imageUrl} alt={name} className="w-16 h-16 rounded-full object-cover border-2 border-cyan-400/50" data-id="element-111" />}
            <div data-id="element-112">
              <p className="font-bold text-white text-xl mb-1" data-id="element-113">{name}</p>
              <p className="text-base text-fuchsia-300 font-semibold" data-id="element-114">{role}</p>
            </div>
          </div>
          <div className="inline-block bg-gradient-to-r from-cyan-500 to-fuchsia-500 px-4 py-2 rounded-full" data-id="element-115">
            <p className="text-sm font-bold text-white" data-id="element-116">{result}</p>
          </div>
        </div>
      </div>
    </div>;
}